<template>

<div>
  <div v-if="allNotifications.length > 0" class="notification-panel">
    <div class="container-fluid xs-pt-0">
      <div class="row">
        <div class="col-md-12">
          <div class="xs-pl-10 xs-pr-10">
            <h3>Notifications</h3>
            <NotificationList :show-delete="true" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <PageHeader title="Subject Shelf" subtitle="Organize your study material">
    <router-link slot="top" class="btn btn-primary" style="float: right;"  :to="{name: 'importer'}" v-if="showImport">
      <i class="icon mdi mdi-cloud-upload"></i> &nbsp;Import Notes
    </router-link>
  </PageHeader>

  <div class="main-content container-fluid xs-pt-0">
    <div class="row">
      <div class="col-md-12">

        <!-- No content to display -->
        <Panel v-if=" !subjects || !subjects.length">
          <PanelBody>
            <p v-if=" !subjects"><LoadingIndicator></LoadingIndicator></p>
            <div v-else-if=" !subjects.length">
              <div v-if="showImport">
                <h3>Welcome to CLEX</h3>
                This is where all your subjects and lecture notes will display.<br /><br />
                <router-link :to="{name: 'importer'}" class="btn btn-primary btn-lg">Import your first Lecture Note</router-link>
              </div>
              <div v-if="!showImport">
                <h3>Welcome to CLEX</h3>
                Your course materials will display here once your school has uploaded study notes.
              </div>
            </div>
          </PanelBody>
        </Panel>

        <!-- There is content to display -->
        <div v-else>
          <div v-for="subject in subjects">
            <SubjectShelfSubject :subject="subject" />
          </div>
        </div><!-- /.v-else -->

      </div><!-- /.col -->
    </div><!-- /.row -->
  </div><!-- /.main-content -->
</div><!-- /div -->

</template>

<script>
import Subject from '../../resources/subject';
import SubjectShelfSubject from './SubjectShelfSubject'
import NotificationList from '../notifications/NotificationList'

import { mapState, mapActions, mapGetters } from 'vuex';
import { directive as onClickAway } from 'vue-clickaway';

export default {
  components: {
    SubjectShelfSubject,
    NotificationList,
  },

  created() {
    // Fetch data
    this.getSubjects();
    this.getChapters();
    this.getMicroNotes();
  },

  methods: {
    ...mapActions([
      'getSubjects',
      'getChapters',
      'getMicroNotes',
    ])
  },

  computed: {
    ...mapState([
      'currentUser',
    ]),

    ...mapGetters({
      subjects: 'allSubjects',
      allNotifications: 'allNotifications',
    }),

    showImport() {
      return this.currentUser.role !== 'student';
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// SubjectShelf.vue?9fdddf5e